export const fileupload = {
  colorScheme: {
    dark: {
      header: {
        padding: '0',
      },
      content: {
        padding: '0',
      },
    },
  },
};
